export const isFeatureToggleRBACEnabled = (ftRBACToggle: boolean): boolean =>
  ftRBACToggle;
